import { RefreshRounded } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { clearStorage as actionClearStorage } from '../../../../redux/actions/auth'
import { StyledReportButton } from '../../styles/HeaderStyles'

function ResetButton(admin: any) {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const handleClick = () => {
    dispatch(actionClearStorage())
  }

  return (
    <Tooltip title={`${t('clear-cache')}`}>
      <StyledReportButton
        variant="text"
        className={admin ? 'admin' : ''}
        startIcon={<RefreshRounded style={{ fontSize: 20 }} />}
        aria-controls="share-link-menu"
        aria-haspopup="false"
        onClick={handleClick}
      >
        {t('restart')}
      </StyledReportButton>
    </Tooltip>
  )
}

export default ResetButton
